module.exports = __webpack_public_path__ + "static/media/abbey-park-3.a74e5119.jpg";